import './style.sass';

import React, { useEffect, useRef } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const UkassaResult = () => {
    const checkScroll = () => {
        const positionChart1 = refChart1.current.offsetTop;
        const positionChart2 = refChart2.current.offsetTop;
        const positionChart3 = refChart3.current.offsetTop;
        const positionWindow = window.pageYOffset + window.innerHeight;
        if (positionWindow >= positionChart1 && !refChart1.current.classList.contains('active')) {
            refChart1.current.classList.add('active');
        }
        if (positionWindow >= positionChart2 && !refChart2.current.classList.contains('active')) {
            refChart2.current.classList.add('active');
        }
        if (positionWindow >= positionChart3 && !refChart3.current.classList.contains('active')) {
            refChart3.current.classList.add('active');
        }
    };

    const refChart1 = useRef();
    const refChart2 = useRef();
    const refChart3 = useRef();

    useEffect(() => {
        document.addEventListener('scroll', checkScroll);
        return () => {
            document.removeEventListener('scroll', checkScroll);
        };
    }, []);

    return (
        <div className="ukassa-result">
            <FullWrapper bigPaddings isMargin={false}>
                <span className="ukassa-result__title">Результаты</span>
                <div className="ukassa-result__list">
                    <ScrollAnimation
                        delay={0}
                        animateIn="fadeIn"
                        offset={300}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="ukassa-result__item">
                            <span className="ukassa-result__item-title">Позиции</span>
                            <span className="ukassa-result__item-text">
                                На графиках показана группа приоритетных запросов, которая при смене
                                домена просела. Но по прошествии двух месяцев ситуация улучшилась и
                                рост продолжается.
                            </span>
                            <img
                                src="/images/svg/ukassa/positionChart.svg"
                                alt=""
                                className="ukassa-result__item-img"
                                loading="lazy"
                            />
                            <span className="ukassa-result__metric-text">Яндекс Метрика</span>
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        delay={0}
                        animateIn="fadeIn"
                        offset={300}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="ukassa-result__item">
                            <span className="ukassa-result__item-title">Трафик</span>
                            <span className="ukassa-result__item-text">
                                Просадка небрендового трафика составила около 40-45% за неделю, но
                                спустя 3 месяца объем вернулся к изначальному показателю.
                            </span>
                            <span className="ukassa-result__item-text ukassa-result__item-text--bold">
                                Динамика позиции группы запросов перового приоритета после переезда
                                и ребрендинга за период с декабря 2020 по апрель 2021:
                            </span>
                            <div ref={refChart1} className="ukassa-result__wrap-chart">
                                <img src="/images/svg/ukassa/greenChart.svg" alt="" />
                            </div>
                            <div ref={refChart2} className="ukassa-result__wrap-chart">
                                <img src="/images/svg/ukassa/blueChart.svg" alt="" />
                            </div>
                            <div ref={refChart3} className="ukassa-result__wrap-chart">
                                <img src="/images/svg/ukassa/secondGreenChart.svg" alt="" />
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            </FullWrapper>
        </div>
    );
};

export default UkassaResult;
